"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireWildcard(require("react")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _getAlias = _interopRequireDefault(require("@devsta/get-alias")),
    _reactRouterDom = require("react-router-dom"),
    _clientAwsS = require("@devsta/client-aws-s3"),
    _clientAuth = require("@devsta/client-auth"),
    _AuthorisationContext = _interopRequireDefault(require("../context/AuthorisationContext")),
    _Error = _interopRequireDefault(require("../../Error")),
    _isShootstaOrgId = _interopRequireDefault(require("../../../common/utils/isShootstaOrgId")),
    _isShootstaEditor = _interopRequireDefault(require("../../../common/utils/isShootstaEditor")),
    _isShootstaAdmin = _interopRequireDefault(require("../../../common/utils/isShootstaAdmin")),
    _isShootstaSeniorEditor = _interopRequireDefault(require("../../../common/utils/isShootstaSeniorEditor"));

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function formatOrganisation(a) {
  var b = a.orgPackage,
      c = (0, _objectWithoutProperties2["default"])(a, ["orgPackage"]);
  return _objectSpread(_objectSpread({}, c), {}, {
    includedAddonTypes: b ? b.includedAddonTypes : []
  });
}

var AuthorisationProvider = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.getProviderValue = (0, _memoizeOne["default"])(function (a) {
      var b = d.state.organisationMemberships;
      return a ? {
        organisationMemberships: b || [],
        isShootsta: (0, _isShootstaOrgId["default"])(a.organisationId),
        isShootstaEditor: d.isShootstaEditor(),
        isShootstaAdmin: d.isShootstaAdmin(),
        selectedOrganisation: a,
        updateSelectedOrganisation: d.updateSelectedOrganisation,
        updateSelectedOrganisationData: d.updateSelectedOrganisationData
      } : {
        organisationMemberships: b || [],
        isShootsta: !1,
        isShootstaEditor: !1,
        isShootstaAdmin: !1,
        selectedOrganisation: {
          organisationId: null,
          includedAddonTypes: [],
          permissions: [],
          preferences: {}
        },
        updateSelectedOrganisation: d.updateSelectedOrganisation,
        updateSelectedOrganisationData: d.updateSelectedOrganisationData
      };
    }), d.updateSelectedOrganisation = function (a) {
      var b = a.alias,
          c = (0, _getAlias["default"])(),
          d = window.location,
          e = d.hostname,
          f = d.protocol,
          g = e.split("."),
          h = (0, _toConsumableArray2["default"])(g);
      return h[0].includes(c) ? "shootsta" === b ? (h.splice(0, 1), void (window.location.href = "".concat(f, "//").concat(h.join(".")))) : void (h.splice(0, 1, b), window.location.href = "".concat(f, "//").concat(h.join("."))) : void (window.location.href = "".concat(f, "//").concat(["shootsta" === b ? "" : b].concat((0, _toConsumableArray2["default"])(h)).join(".")));
    }, d.updateSelectedOrganisationData = function (a) {
      d.setState(function (b) {
        var c = b.selectedOrganisation;
        return {
          selectedOrganisation: _objectSpread(_objectSpread({}, c), a)
        };
      });
    }, d.getCurrentOrganisation = function (a) {
      var b = (0, _getAlias["default"])(),
          c = b ? a.find(function (a) {
        var c = a.organisation;
        return c.alias === b;
      }) || {
        organisation: null
      } : a[0],
          d = c.organisation;
      return d;
    }, d.getShootstaOrganisation = function (a) {
      var b = a.find(function (a) {
        var b = a.organisation;
        return "shootsta" === b.alias;
      }) || {
        organisation: null
      },
          c = b.organisation;
      return c;
    }, d.getOrganisationById = function (a, b) {
      if (!a) return null;
      var c = b.find(function (b) {
        var c = b.organisation;
        return c.organisationId === a;
      }) || {},
          d = c.organisation;
      return d;
    }, d.resolveOrgProfileImages = function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b, c) {
        var e, f, g, h;
        return _regenerator["default"].wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                if (b && b.length && c) {
                  a.next = 2;
                  break;
                }

                return a.abrupt("return");

              case 2:
                return e = c.organisationId, f = d.props.apiClient, a.prev = 4, a.next = 7, (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: f,
                  dataArray: b.map(function (a) {
                    return _objectSpread(_objectSpread({}, a), {}, {
                      organisationId: a.organisation.organisationId
                    });
                  }),
                  substitutedKeys: [{
                    key: "organisation",
                    subKeys: ["imageUrl"]
                  }]
                });

              case 7:
                g = a.sent, d.setState({
                  organisationMemberships: g,
                  selectedOrganisation: d.getOrganisationById(e, g)
                }), a.next = 15;
                break;

              case 11:
                a.prev = 11, a.t0 = a["catch"](4), h = b.map(function (a) {
                  return _objectSpread(_objectSpread({}, a), {}, {
                    organisation: _objectSpread(_objectSpread({}, a.organisation), {}, {
                      imageUrl: void 0
                    })
                  });
                }), d.setState({
                  organisationMemberships: h,
                  selectedOrganisation: d.getOrganisationById(e, h)
                });

              case 15:
              case "end":
                return a.stop();
            }
          }
        }, a, null, [[4, 11]]);
      }));
      return function () {
        return a.apply(this, arguments);
      };
    }(), d.isShootstaEditor = function () {
      var a = d.state.organisationMemberships,
          b = void 0 === a ? [] : a;
      return !!b.filter(function (a) {
        return (0, _isShootstaEditor["default"])(a.role.name, a.status) || (0, _isShootstaSeniorEditor["default"])(a.role.name, a.status);
      }).length;
    }, d.isShootstaAdmin = function () {
      var a = d.state.organisationMemberships,
          b = void 0 === a ? [] : a;
      return !!b.filter(function (a) {
        return (0, _isShootstaAdmin["default"])(a.role.name, a.status);
      }).length;
    }, d.componentDidMount = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return b = d.props, c = b.getOrgMemberships, e = b.getOrganisationByAlias, f = _clientAuth.credentials.get().user || {}, g = f.userId, h = void 0 === g ? "" : g, i = f.initialSetup, j = void 0 === i || i, a.prev = 2, j || d.setState({
                redirect: "/user-settings/edit/".concat(h, "?modal=1")
              }, function () {
                d.setState({
                  redirect: void 0
                });
              }), a.next = 6, c();

            case 6:
              if (k = a.sent, l = k.data, m = k.error, !m && l && l.getOrgMemberships) {
                a.next = 11;
                break;
              }

              return a.abrupt("return", void d.setState({
                error: !0
              }));

            case 11:
              if (n = l.getOrgMemberships, o = n.map(function (a) {
                var b = a.organisation,
                    c = (0, _objectWithoutProperties2["default"])(a, ["organisation"]);
                return _objectSpread(_objectSpread({}, c), {}, {
                  organisation: formatOrganisation(b)
                });
              }), o.length) {
                a.next = 15;
                break;
              }

              return a.abrupt("return", void d.setState({
                organisationMemberships: [],
                selectedOrganisation: null
              }));

            case 15:
              if (p = o.map(function (a) {
                var b = a.role,
                    c = (0, _objectWithoutProperties2["default"])(a, ["role"]);
                return _objectSpread(_objectSpread({}, c), {}, {
                  roleId: b.roleId,
                  roleName: b.name
                });
              }), q = d.getCurrentOrganisation(p), r = q && p.some(function (a) {
                var b = a.organisation.organisationId,
                    c = a.status;
                return b === q.organisationId && "PENDING" === c;
              }), !r) {
                a.next = 20;
                break;
              }

              return a.abrupt("return", void d.setState({
                redirect: "/user-settings/invite"
              }));

            case 20:
              if (s = o.filter(function (a) {
                var b = a.status;
                return "ACCEPTED" === b;
              }), s.length) {
                a.next = 23;
                break;
              }

              return a.abrupt("return", void d.setState({
                organisationMemberships: [],
                selectedOrganisation: null
              }));

            case 23:
              if (!q) {
                a.next = 26;
                break;
              }

              return d.resolveOrgProfileImages(s, q), a.abrupt("return", void d.setState({
                organisationMemberships: s,
                selectedOrganisation: q
              }));

            case 26:
              if (t = d.getShootstaOrganisation(s), t && t.permissions.length) {
                a.next = 29;
                break;
              }

              return a.abrupt("return", void d.setState({
                organisationMemberships: [],
                selectedOrganisation: null
              }));

            case 29:
              return a.next = 31, e((0, _getAlias["default"])());

            case 31:
              if (u = a.sent, v = u.data.getOrganisationByAlias, w = u.error, !w && v) {
                a.next = 36;
                break;
              }

              return a.abrupt("return", void d.setState({
                error: !0
              }));

            case 36:
              d.setState({
                organisationMemberships: s,
                selectedOrganisation: _objectSpread(_objectSpread({}, formatOrganisation(v)), {}, {
                  permissions: t.permissions
                })
              }), a.next = 42;
              break;

            case 39:
              a.prev = 39, a.t0 = a["catch"](2), d.setState({
                error: !0
              });

            case 42:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[2, 39]]);
    })), d.state = {
      error: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props.children,
          b = this.state,
          c = b.selectedOrganisation,
          d = b.error,
          e = b.organisationMemberships,
          f = b.redirect;
      return f ? _react["default"].createElement(_reactRouterDom.Redirect, {
        to: f,
        push: !0
      }) : d ? _react["default"].createElement(_Error["default"], null) : e ? _react["default"].createElement(_AuthorisationContext["default"].Provider, {
        value: this.getProviderValue(c)
      }, a) : null;
    }
  }]), b;
}(_react.Component);

exports["default"] = AuthorisationProvider;